import {EventType, EventKind} from 'services/analytics/const';
import {buildEventCreator, withoutOverrides} from 'services/analytics';

export const name = EventKind.OpenHistory;
export const converter = withoutOverrides;
export const createEvent = buildEventCreator<EventType.Detailed, OpenHistoryEventPayload>({
  name,
  converter,
});
